// @ts-nocheck
import React, { FC } from 'react';

import Loadable from 'Jsx/Shared/Loadable';
import { GetLeadSectionProps } from './GetLeadSection';

const LazyCardLead: FC<GetLeadSectionProps> = props => (
  <Loadable
    Loader={<div className="h-full w-full bg-gray-light"> </div>}
    module={() =>
      import(
        /* webpackChunkName: "get-lead-section" */
        './GetLeadSection'
      )
    }
    {...props}
  />
);

export default LazyCardLead;
